import * as dataStore from './DataStore';
import { getSiteFromLink } from './MoreAboutThisTitleSelector';
import { getTitleUi } from './TitleInfoSelector';

/**
 * @returns the book chat link info
 */
export function getLinkToBookChatInfo() {
	const store = dataStore.getJsonData();
	const chatLink = store.FeatureContent.LinkToBookChat;

	return chatLink ? {
		link: chatLink.LinkToBookChat,
		destId: getSiteFromLink(chatLink.LinkToBookChat),
		srcId: getTitleUi(store)
	} : null;
}


// WEBPACK FOOTER //
// ./src/data/LinkToBookChatSelector.js